import {
  FormSchemaConverter,
  IFileInputElement,
  RepeatableMetaInfo,
  isInputElement,
  isFileInputElement,
} from "@graffer-inc/form-schema";
import { IFormSchemaV2 } from "@graffer-inc/form-schema/dist/form-schema/form-schema";

export const getTotalMaxFileSize = (formSchema: IFormSchemaV2): number => {
  const flatElements = new FormSchemaConverter(formSchema).expand();
  const fileInputs: IFileInputElement[] = flatElements.filter(
    (e): e is IFileInputElement & RepeatableMetaInfo =>
      isInputElement(e) && isFileInputElement(e),
  );
  return fileInputs.reduce(
    (previousValue, currentValue: IFileInputElement) =>
      previousValue + currentValue.maxSize,
    0,
  );
};
